import React, { Component } from 'react'
import PropTypes from 'prop-types'

import styles from './dataPlaceholder.module.scss'

class DataPlaceholder extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
            .isRequired,
        img: PropTypes.string.isRequired,
    }

    render() {
        const { title, subtitle, img } = this.props

        return (
            <div className={styles.noActionsPlaceholder}>
                <img src={img} alt="no actions" />
                <p className={styles.placeholderTitle}>{title}</p>
                <p className={styles.placeholderSubtitle}>{subtitle}</p>
            </div>
        )
    }
}

export default DataPlaceholder
